import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import Cookies from "js-cookie";
import axios from "axios";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  Modal,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import PopupError from "./Generics/PopupError";
import ModalHelper from "./Generics/Modal/ModalHelper";
import "../assets/css/modal.css";
import ModalError from "./Generics/Modal/ModalError";
import ModalConferma from "./Generics/Modal/ModalConferma";
import ModalSuccess from "./Generics/Modal/ModalSuccess";
import ModalSignatureType from "./Generics/Modal/ModalSignatureType";
import mobilePrefixes from "../utils/mobile-prefixes.json";

const NuovaPraticaForm = () => {
  const [files, setFiles] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [department, setDepartment] = useState("");
  const [departmentsList, setDepartmentsList] = useState([]);
  const [signers, setSigners] = useState([]);
  const [readers, setReaders] = useState([]);
  const [message, setMessage] = useState([]);
  const [messageEmailValidation, setMessageEmailValidation] = useState([]);
  const [colorMessage, setColorMessage] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [signerData, setSignerData] = useState({
    signer_firstname: "",
    signer_lastname: "",
    signer_email: "",
    signer_phone_number: "",
  });

  const [changeSigner, setChangeSigner] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone_number: "",
  });
  const [readerData, setReaderData] = useState({
    reader_firstname: "",
    reader_lastname: "",
    reader_email: "",
  });
  const [paperwork, setPaperwork] = useState("");
  const fileInputRef = useRef(null);
  const [tmpEmailChangeSigner, setTmpEmailChangeSigner] = useState("");
  const [prefix, setPrefix] = useState("+39");
  const [inputSignerPhone, setInputSignerPhone] = useState("");
  const [validated, setValidated] = useState(false);
  const [emailCheckValidation, setEmailCheckValidation] = useState("");
  const arrChangeSigner = [];
  const [changePrefixList, setChangePrefixList] = useState([]);
  const [error, setError] = useState(false);
  const [errorCall, setErrorCall] = useState(false);
  const [missingFields, setMissingFields] = useState([]);
  const [confirmSignModal, setConfirmSignModal] = useState(false);
  const [successStart, setSuccessStart] = useState(false);
  const [showSignatureTypeModal, setShowSignatureTypeModal] = useState(true);
  const [signatureLevel, setSignatureLevel] = useState("");
  const [authenticationMode, setAuthenticationMode] = useState("");

  const [messageError, setMessageError] = useState({
    title: "Request Failed",
    descriptionOne: "",
    descriptionTwo: "",
  });

  const tooltipContent = {
    NameOperation: {
      infoTitle: "Nome operazione",
      description: "Il nome dell’operazione sarà visibile ai firmatari.",
      descriptionBis: "",
    },
    DocumentPdf: {
      infoTitle: "Documenti",
      description: "Copy",
      descriptionBis: "",
    },
  };

  const [modalHelperOpen, setModalHelperOpen] = useState(false);
  const [modalObjectInfo, setModalObjectInfo] = useState({});

  const handleModalHelperClick = (objectInfo) => {
    setModalObjectInfo(objectInfo);
    setModalHelperOpen(true);
  };

  const handleCloseHelperModal = () => {
    setModalHelperOpen(false);
    setModalObjectInfo({});
  };

  const closePopupError = () => {
    setError(false);
  };

  const handleSignatureTypeConfirm = (selection) => {
    setSignatureLevel(selection.signatureLevel);
    setAuthenticationMode(selection.authenticationMode);
    setShowSignatureTypeModal(false);
  };

  /**
   * Controlla se l'utente è loggato, se non è loggato
   * viene reindirizzato alla pagina di login
   */

  const access_token = localStorage.getItem("token");

  // let access_token = Cookies.get("access_token");

  const [data, setData] = useState([]);
  const [responseEp, setResponseEp] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  let endpoint = process.env.REACT_APP_ENPOINT + "is-user-logged";

  const isUserLogged = async () => {
    //e.preventDefault();
    const response = await fetch(endpoint, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Authorization: "Bearer " + access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    const result = await response.json();
    //result === 'auth' ? navigate('/signing-pending') : null;
    if (result === "auth") {
      setIsLoggedIn(true);
    }
    return result;
  };

  useEffect(() => {
    isUserLogged();
  }, []);

  // modali

  const [openSigner, setOpenSigner] = useState(false);

  const [openReader, setOpenReader] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingReader, setEditingReader] = useState(null);

  // SIGNER

  const handleShowSigner = () => {
    setIsEditMode(false);
    setSignerData({
      signer_firstname: "",
      signer_lastname: "",
      signer_email: "",
      signer_phone_number: "",
    });
    setOpenSigner(true);
  };

  const handleChangeSigner = (change) => {
    setIsEditMode(true);
    setChangeSigner(change);

    const fullNumber = change.phone_number || "";

    const prefixValue = fullNumber.slice(0, 3);
    const numberValue = fullNumber.slice(3);

    setPrefix(prefixValue);
    setSignerData({
      signer_firstname: change.firstname,
      signer_lastname: change.lastname,
      signer_email: change.email,
      signer_phone_number: numberValue,
    });

    setOpenSigner(true);
  };

  const handleSubmitSigner = () => {
    const {
      signer_firstname,
      signer_lastname,
      signer_email,
      signer_phone_number,
    } = signerData;

    const regex = /^[^@ ]+@[^@ ]+\.[^@ ]+$/;
    const pattern = /^\s+|\s+$/g;
    const validEmail = signer_email.replace(pattern, "");

    const missingFields = [];
    let hasError = false;

    if (!signer_firstname.trim()) {
      missingFields.push("signer_firstname");
      hasError = true;
    }

    if (!signer_lastname.trim()) {
      missingFields.push("signer_lastname");
      hasError = true;
    }

    if (!validEmail) {
      missingFields.push("signer_email");
      hasError = true;
    }

    // Telefono obbligatorio solo se authenticationMode richiede SMS
    if (authenticationMode === "otp_sms" && !signer_phone_number.trim()) {
      missingFields.push("signer_phone_number");
      hasError = true;
    }

    if (!regex.test(validEmail)) {
      missingFields.push("signer_email_invalid");
      hasError = true;
      setMessageEmailValidation(
        "L’email inserita non sembra avere un formato valido. Potrebbe bloccare il processo di firma. Verifica che non ci siano spazi vuoti all’inizio o alla fine."
      );
      setColorMessage("red-message");
    }

    if (hasError) {
      setError(true);
      setTimeout(() => setError(false), 5000);
      setMissingFields(missingFields);
      return;
    } else {
      setMissingFields([]);
    }

    const formattedSigner = [
      {
        firstname: signer_firstname.trim(),
        lastname: signer_lastname.trim(),
        email: validEmail,
        phone_number: authenticationMode === "otp_sms" ? `${prefix}${signer_phone_number.trim()}` : "",
      },
    ];

    setMessageEmailValidation("");
    setColorMessage("black-message");

    if (isEditMode) {
      const originalEmail = changeSigner.email;
      setSigners((prev) =>
        prev.map((item) =>
          item[0].email === originalEmail ? formattedSigner : item
        )
      );
    } else {
      const isFound = signers.some((signer) => signer[0].email === validEmail);
      if (!isFound) {
        setSigners((prev) => [...prev, formattedSigner]);
      }
    }

    setSignerData({
      signer_firstname: "",
      signer_lastname: "",
      signer_email: "",
      signer_phone_number: "",
    });
    setPrefix("+39");
    setOpenSigner(false);
    setIsEditMode(false);
    setMissingFields((prev) => prev.filter((field) => field !== "signers"));
  };

  const handleGoBackSigner = () => {
    setMessageEmailValidation("");
    setColorMessage("black-message");
    setOpenSigner(false);
  };

  const handleRemoveSigner = (remove) => () => {
    setSigners((prev) => prev.filter((el) => el[0].email !== remove));
    setOpenSigner(false);
  };

  const form = useRef(null);

  // READER

  const handleEditReader = (reader) => {
    setReaderData({
      reader_firstname: reader.firstname,
      reader_lastname: reader.lastname,
      reader_email: reader.email,
    });
    setEditingReader(reader.email);
    setOpenReader(true);
  };

  const handleUpdateReader = () => {
    setReaders((prev) =>
      prev.map((el) =>
        el[0].email === editingReader ? [{ ...el[0], ...readerData }] : el
      )
    );
    setOpenReader(false);
    setEditingReader(null);
    setReaderData({
      reader_firstname: "",
      reader_lastname: "",
      reader_email: "",
    });
  };

  const handleGoBackLettore = () => {
    setOpenReader(false);
    setEditingReader(null);
    setReaderData({
      reader_firstname: "",
      reader_lastname: "",
      reader_email: "",
    });
  };

  const handleSaveReader = () => {
    const { reader_firstname, reader_lastname, reader_email } = readerData;

    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    const pattern = /^\s+|\s+$/g;

    let validEmailR = reader_email.replace(pattern, "");
    const missingFields = [];
    let hasError = false;

    if (!reader_firstname || !reader_firstname.trim()) {
      missingFields.push("reader_firstname");
      hasError = true;
    }

    if (!reader_lastname || !reader_lastname.trim()) {
      missingFields.push("reader_lastname");
      hasError = true;
    }

    if (!reader_email || !reader_email.trim()) {
      missingFields.push("reader_email");
      hasError = true;
    } else if (!regex.test(validEmailR)) {
      missingFields.push("reader_email_invalid");
      hasError = true;
      setMessageEmailValidation(
        "L’email inserita non sembra avere un formato valido. Potrebbe bloccare il processo di firma. Verifica che non ci siano spazi vuoti all’inizio o alla fine."
      );
      setColorMessage("red-message");
    }

    if (hasError) {
      setError(true);
      setTimeout(() => setError(false), 5000);
      setMissingFields(missingFields);
      return;
    } else {
      setMissingFields([]);
    }

    const newReader = {
      firstname: reader_firstname.trim(),
      lastname: reader_lastname.trim(),
      email: validEmailR.trim(),
    };

    setMessageEmailValidation("");
    setColorMessage("black-message");

    if (editingReader) {
      setReaders((prev) =>
        prev.map((r) => (r.email === editingReader ? newReader : r))
      );
    } else {
      const isFound = readers.some((r) => r.email === reader_email);
      if (!isFound) {
        setReaders((prev) => [...prev, newReader]);
      }
    }

    setOpenReader(false);
    setEditingReader(null);
    setReaderData({
      reader_firstname: "",
      reader_lastname: "",
      reader_email: "",
    });
    setMissingFields((prev) => prev.filter((field) => field !== "readers"));
  };

  const handleRemoveReader = (remove) => () => {
    setReaders((prev) =>
      prev.filter((el) => el && el.email && el.email !== remove)
    );
    setOpenReader(false);
  };

  // SELECT DEPARTMENT

  let endpointDep = process.env.REACT_APP_ENPOINT + "departments";
  const getDepartmentsList = async () => {
    //e.preventDefault();
    const response = await axios({
      method: "get",
      url: endpointDep,
      data: data,
      headers: {
        Authorization: `Bearer ${access_token}`,
        Accept: "application/json",
      },
    });
    const result = response.data;

    setDepartmentsList(result);
    return result;
  };

  useEffect(() => {
    getDepartmentsList();
  }, []);

  const renderDepartmentsList = departmentsList.map((item, index) => {
    return (
      <MenuItem key={item.id} value={item.id}>
        {item.department_name}
      </MenuItem>
    );
  });

  const handleChangeDepartmentsSelect = (event) => {
    setDepartment(event.target.value);
  };

  // READER

  const handleShowLettore = () => {
    setIsEditMode(false);
    setReaderData({
      reader_firstname: "",
      reader_lastname: "",
      reader_email: "",
      reader_phone_number: "",
    });
    setOpenReader(true);
  };

  const handleChangePaperwork = (input) => {
    setPaperwork(input.value);
  };

  const handleChangeEmail = (input) => {
    setEmailCheckValidation(input.value);

    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    //const pattern = /^[-a-zA-Z0-9-()]+(\s+[-a-zA-Z0-9-()]+)*$/i;
    const pattern = /^\s+|\s+$/g;

    input.value.replace(pattern, "");

    if (regex.test(input.value) === true) {
      setMessageEmailValidation("Valid email format.");
      setColorMessage("black-message");
    }
    //setPaperwork(input.value);
  };

  const handleChangeDropDown = (e) => {
    setPrefix(e.target.value);
  };

  const handleChangeFile = (filesUp) => {
    let count = 0;
    for (let i = 0; i < filesUp.length; i++) {
      const isFound = files.some((file) => {
        if (file.name === filesUp[i].name) {
          setMessage((a) => [
            ...a,
            "Non puoi aggiungere lo stesso file più volte o file con lo stesso nome: " +
            file.name,
          ]);
          count++;
          return true;
        }
        return false;
      });

      if (!isFound) setFiles((a) => [...a, filesUp[i]]);
    }
    if (filesUp.length - count > 0)
      setMessage((a) => [
        ...a,
        filesUp.length - count + "file inserted. You can upload further files.",
      ]);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFiles = event.dataTransfer.files;
    if (droppedFiles && droppedFiles.length > 0) {
      handleChangeFile(droppedFiles);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleRemoveFile = (remove) => {
    setFiles((prev) => prev.filter((el) => el.name !== remove));

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const subimtData = (e) => {
    e.preventDefault();

    const fData = new FormData();
    const missingFields = [];

    let hasError = false;

    if (paperwork.length === 0) {
      missingFields.push("paperwork");
      hasError = true;
    }

    if (department.length === 0) {
      missingFields.push("department");
      hasError = true;
    }

    if (files.length === 0) {
      missingFields.push("files");
      hasError = true;
    }

    if (signers.length === 0) {
      missingFields.push("signers");
      hasError = true;
    }

    if (readers.length === 0) {
      missingFields.push("readers");
      hasError = true;
    }

    if (hasError) {
      setError(true);
      setTimeout(() => setError(false), 5000);
      setMissingFields(missingFields);
      return;
    } else {
      setMissingFields([]);
    }

    setLoading(true);

    for (let n = 0; n < files.length; ++n) {
      fData.append("FileList[]", files[n]);
    }

    fData.append("Paperwork", paperwork);

    signers.forEach((item) => {
      fData.append("Signers[]", JSON.stringify(item[0]));
    });

    // readers.forEach((item) => {
    //   fData.append("Readers[]", JSON.stringify(item[0]));
    // });

    if (Array.isArray(readers) && readers.length > 0) {
      readers.forEach((item) => {
        if (Array.isArray(item) && item[0]) {
          fData.append("Readers[]", JSON.stringify(item[0]));
        } else if (item) {
          fData.append("Readers[]", JSON.stringify(item));
        }
      });
    }

    fData.append("Departments[]", department);
    fData.append("SignatureLevel", signatureLevel);
    fData.append("AuthenticationMode", authenticationMode);

    const endpoint = process.env.REACT_APP_ENPOINT + "signing-new";

    axios
      .post(endpoint, fData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + access_token,
        },
      })
      .then((res) => {
        setLoading(false);
        setConfirmSignModal(false);
        setSuccessStart(true);
      })
      .catch((e) => {
        setLoading(false);
        setErrorCall(true);
        setConfirmSignModal(false);

        const errorMessage = e.response?.data?.message || e.response?.data?.error || e.message;
        const errorDetails = e.response?.data?.details || "";

        setMessageError({
          title: "Errore nella creazione del signing",
          descriptionOne: errorMessage || "La richiesta non può essere elaborata a causa di un errore tecnico temporaneo.",
          descriptionTwo: errorDetails || "Riprova tra qualche minuto.",
        });
        console.error("Errore creazione signing:", e.response?.data || e);
      });
  };

  const handleShowFileInput = () => {
    fileInputRef.current.click();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSignerData((prev) => ({ ...prev, [name]: value }));
  };

  const handleChangeReader = (e) => {
    const { name, value } = e.target;
    setReaderData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCloseErrorCallModal = () => {
    setErrorCall(false);
  };

  const handleConfirmSignModal = () => {
    const missingFields = [];

    let hasError = false;

    if (paperwork.length === 0) {
      missingFields.push("paperwork");
      hasError = true;
    }

    if (department.length === 0) {
      missingFields.push("department");
      hasError = true;
    }

    if (files.length === 0) {
      missingFields.push("files");
      hasError = true;
    }

    if (signers.length === 0) {
      missingFields.push("signers");
      hasError = true;
    }

    if (readers.length === 0) {
      missingFields.push("readers");
      hasError = true;
    }

    if (hasError) {
      setError(true);
      setTimeout(() => setError(false), 5000);
      setMissingFields(missingFields);
      return;
    }
    setConfirmSignModal(true);
  };

  const handleCloseModalConfirmSign = () => {
    setConfirmSignModal(false);
  };

  const handleCloseSuccessStartModal = () => {
    setSuccessStart(false);
    window.location.href = "/signing-pending";
  };

  return (
    <>
      <Grid
        container
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "150px",
          marginBottom: "100px",
        }}
      >
        <Grid item xs={10} sm={10}>
          <Typography
            className="color-blue-dark"
            style={{
              fontSize: "22px",
              fontWeight: 600,
              marginBottom: "30px",
            }}
          >
            Nuovo signing{" "}
            {signatureLevel && (
              <span style={{ fontSize: "14px", fontWeight: 400 }}>
                (con Firma Elettronica {signatureLevel === "advanced" ? "Avanzata" : "Semplice"})
              </span>
            )}
          </Typography>
          <form
            ref={form}
            id="register-new-signing-process"
            onSubmit={subimtData}
          >
            {/* name & department  */}
            <Grid
              container
              item
              xs={12}
              spacing={4}
              style={{ justifyContent: "space-around", marginBottom: "30px" }}
            >
              <Grid container item xs={12} md={4}>
                <div style={{ display: "flex" }}>
                  <Typography className="color-blue-dark title-input">
                    Nome operazione
                  </Typography>
                  <div
                    className="icon-modal-info"
                    style={{
                      marginLeft: "10px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      handleModalHelperClick(tooltipContent.NameOperation)
                    }
                  />
                </div>
                {/* <Typography className="color-blue-dark title-input">
                    Warning! Operation name will be visible to the signers.
                  </Typography> */}

                <TextField
                  error={missingFields.includes("paperwork")}
                  fullWidth
                  variant="outlined"
                  name={"name_paperwork"}
                  style={{ marginTop: "10px" }}
                  placeholder="Inserisci"
                  onChange={(e) => handleChangePaperwork(e.target)}
                  required
                />
              </Grid>

              <Grid container item xs={12} md={4}>
                <div style={{ display: "flex" }}>
                  <Typography className="color-blue-dark title-input">
                    Team
                  </Typography>
                </div>

                <Select
                  onChange={handleChangeDepartmentsSelect}
                  displayEmpty
                  error={missingFields.includes("department")}
                  value={department || ""}
                  fullWidth
                  style={{
                    marginTop: "10px",
                    height: "56px",
                  }}
                >
                  <MenuItem value="">
                    <span style={{ color: "#abb0b6" }}>Seleziona</span>
                  </MenuItem>
                  {renderDepartmentsList}
                </Select>
              </Grid>

              <Grid container item xs={12} md={4}></Grid>
            </Grid>

            {/* document pdf */}
            <Grid
              item
              xs={6}
              style={{
                marginTop: "30px",
              }}
            >
              <div style={{ display: "flex" }}>
                <Typography className="color-blue-dark title-input">
                  Documenti da firmare
                </Typography>
              </div>
            </Grid>

            <Grid
              container
              xs={12}
              item
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "30px",
              }}
            >
              <Grid
                xs={12}
                item
                style={{
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                {/* input nascosto */}
                <input
                  type="file"
                  accept="application/pdf"
                  style={{ display: "none" }}
                  multiple
                  ref={fileInputRef}
                  onChange={(e) => handleChangeFile(e.target.files)}
                />

                <Grid
                  id="file-upload-area"
                  item
                  xs={12}
                  sx={{
                    paddingLeft: { xs: "20px", sm: 0 },
                    paddingRight: { xs: "20px", sm: 0 },
                  }}
                  style={{
                    backgroundColor: "#d3d3d382",
                    height: "250px",
                    maxHeight: "500px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    textAlign: "center",
                    border: missingFields.includes("files")
                      ? "1px solid #bc2957"
                      : "none",
                  }}
                  onClick={handleShowFileInput}
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                >
                  <div className="icon-upload-document" />
                  <Typography
                    sx={{ fontSize: { xs: "12px", sm: "16px" } }}
                    className="color-blue-dark"
                  >
                    Seleziona o trascina qui i file
                  </Typography>
                  <Typography
                    sx={{ fontSize: { xs: "12px", sm: "16px" } }}
                    className="color-blue-dark"
                  >
                    Unica estensione accettata: pdf
                  </Typography>
                  <Typography
                    sx={{ fontSize: { xs: "12px", sm: "16px" } }}
                    className="color-blue-dark"
                  >
                    Attenzione! I file devono avere l'ultima pagina mezza vuota in basso per ospitare le firme elettroniche
                  </Typography>
                  <Typography
                    sx={{ fontSize: { xs: "12px", sm: "16px" } }}
                    className="color-blue-dark"
                  >
                    Se i firmatari sono più di 12, lasciare una pagina vuota in fondo al file
                  </Typography>

                  <div
                    style={{
                      marginTop: "20px",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      overflowY: "auto",
                      maxHeight: "300px",
                    }}
                  >
                    {files.map((file, index) => (
                      <Grid
                        container
                        alignItems="center"
                        data-lifilename={file.name}
                        key={file.name}
                        style={{
                          marginBottom: "5px",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          style={{
                            wordBreak: "break-word",
                            color: "#1b2838",
                            textAlign: "center",
                          }}
                          className="truncate-file-name"
                        >
                          {file.name}
                        </Typography>
                        <div
                          data-filename={file.name}
                          id={file.name}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRemoveFile(file.name);
                          }}
                          className="icon-remove-file"
                          style={{
                            marginLeft: "10px",
                            cursor: "pointer",
                          }}
                        ></div>
                      </Grid>
                    ))}
                  </div>
                </Grid>
              </Grid>
            </Grid>

            <Divider className="divider-summary-sign" />

            {/* Signers  */}
            <Grid
              container
              xs={12}
              item
              style={{
                height: "80px",
                alignItems: "center",
              }}
            >
              <Grid item xs={6} style={{ display: "flex" }}>
                <Typography
                  className="color-blue-dark"
                  style={{
                    fontSize: "18px",
                    fontWeight: 500,
                  }}
                >
                  Firmatari
                </Typography>

                {missingFields.includes("signers") && (
                  <div style={{ display: "flex", marginLeft: "30px" }}>
                    <div
                      className="icon-error-message-small"
                      style={{ marginRight: "7px", marginTop: "2px" }}
                    />
                  </div>
                )}
              </Grid>

              <Grid
                item
                xs={6}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  variant="outlined"
                  onClick={handleShowSigner}
                  className={`button-bg-purple-signers`}
                >
                  <Typography
                    sx={{
                      textTransform: "initial",
                      fontSize: { xs: "16px", sm: "18px" },
                      fontWeight: 500,
                    }}
                  >
                    Aggiungi
                  </Typography>
                </Button>
              </Grid>
            </Grid>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <Grid
                item
                container
                xs={12}
                sm={8}
                style={{
                  marginTop: "0px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <TableContainer
                  component={Paper}
                  sx={{ maxWidth: "100%", boxShadow: "none" }}
                >
                  <Table aria-label="simple table">
                    <TableBody>
                      {signers.map((signer, index) => {
                        return (
                          <TableRow
                            data-lifilename={signer[0].email}
                            key={index}
                          >
                            <TableCell
                              sx={{
                                padding: "8px",
                                whiteSpace: { xs: "nowrap", sm: "normal" },
                              }}
                              className="color-blue-dark"
                            >
                              <Typography className="text-table">
                                {signer[0].firstname} {signer[0].lastname}
                              </Typography>
                            </TableCell>

                            <TableCell
                              sx={{
                                padding: "8px",
                                width: "150px",
                                whiteSpace: { xs: "nowrap", sm: "normal" },
                                // textAlign: "center",
                              }}
                            >
                              <Button
                                key={index + "change"}
                                data-filename={index}
                                id={signer[0].email}
                                onClick={() => handleChangeSigner(signer[0])}
                                className={`button-bg-purple-signers`}
                                sx={{
                                  marginBottom: 0,
                                  border: "none",
                                }}
                              >
                                <Typography
                                  style={{
                                    textTransform: "initial",
                                    fontSize: "14px",
                                    fontWeight: 500,
                                  }}
                                >
                                  Modifica
                                </Typography>
                              </Button>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </div>

            {signers && signers.length > 0 && (
              <div style={{ marginTop: "50px" }}></div>
            )}

            <Divider className="divider-summary-sign" />
            {/* readers  */}
            <Grid
              container
              xs={12}
              item
              style={{ height: "80px", alignItems: "center" }}
            >
              <Grid item xs={6} style={{ display: "flex" }}>
                <Typography
                  className="color-blue-dark"
                  style={{
                    fontSize: "18px",
                    fontWeight: 500,
                  }}
                >
                  Lettori
                </Typography>

                {missingFields.includes("readers") && (
                  <div style={{ display: "flex", marginLeft: "25px" }}>
                    <div
                      className="icon-error-message-small"
                      style={{ marginRight: "7px", marginTop: "2px" }}
                    />
                  </div>
                )}
              </Grid>

              <Grid
                item
                xs={6}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  variant="outlined"
                  onClick={handleShowLettore}
                  className={`button-bg-purple-signers`}
                >
                  <Typography
                    sx={{
                      textTransform: "initial",
                      fontSize: { xs: "16px", sm: "18px" },
                      fontWeight: 500,
                    }}
                  >
                    Aggiungi
                  </Typography>
                </Button>
              </Grid>
            </Grid>

            <div style={{ display: "flex", justifyContent: "center" }}>
              {/* lista readers  */}
              <Grid
                item
                container
                xs={8}
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <TableContainer
                  component={Paper}
                  sx={{
                    maxWidth: "100%",
                    boxShadow: "none",
                  }}
                >
                  <Table sx={{ minWidth: 650 }} aria-label="readers table">
                    <TableBody>
                      {readers.map((reader, index) => (
                        <TableRow
                          key={reader.email || index}
                          data-lifilename={reader.email}
                        >
                          <TableCell
                            sx={{
                              padding: "8px",
                              whiteSpace: { xs: "nowrap", sm: "normal" },
                            }}
                            className="color-blue-dark"
                          >
                            <Typography className="text-table">
                              {reader.firstname} {reader.lastname}
                            </Typography>
                          </TableCell>

                          <TableCell
                            sx={{
                              fontSize: "0.9rem",
                              padding: "8px",
                              width: "150px",
                              whiteSpace: { xs: "nowrap", sm: "normal" },
                              // textAlign: "center",
                            }}
                          ></TableCell>

                          <TableCell
                            sx={{
                              padding: "8px",
                              width: "150px",
                              whiteSpace: { xs: "nowrap", sm: "normal" },
                              // textAlign: "center",
                            }}
                          >
                            <Button
                              key={index + "-change-reader"}
                              onClick={() => handleEditReader(reader)}
                              className={`button-bg-purple-signers`}
                              sx={{ border: "none" }}
                            >
                              <Typography
                                style={{
                                  textTransform: "initial",
                                  fontSize: "14px",
                                  fontWeight: 500,
                                }}
                              >
                                Modifica
                              </Typography>
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                {readers && readers.length > 0 && (
                  <div style={{ marginBottom: "120px" }}></div>
                )}
              </Grid>
            </div>

            {/* modal signer  */}
            <Modal
              open={openSigner}
              onClose={handleGoBackSigner}
              aria-labelledby="add-signer-title"
              aria-describedby="add-signer-description"
            >
              <Grid
                container
                item
                xs={11}
                md={5}
                sx={{
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "#fff",
                  maxHeight: "90vh",
                  overflowY: "auto",
                  borderRadius: 2,
                  boxShadow: 24,
                  p: 3,
                }}
              >
                {/* Header */}
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #c6c6c6",
                    paddingBottom: 2,
                    marginBottom: 2,
                  }}
                >
                  <div style={{ display: "flex" }}>
                    <div className="icon-modal-edit" />
                    <Typography
                      id="add-signer-title"
                      className="color-blue-dark"
                      style={{
                        fontSize: "18px",
                        fontWeight: 600,
                        marginTop: "3px",
                      }}
                    >
                      {isEditMode
                        ? "Modifica dati firmatario"
                        : "Aggiungi firmatario"}
                    </Typography>
                  </div>
                  <div
                    onClick={handleGoBackSigner}
                    className="icon-modal-close"
                    style={{ cursor: "pointer" }}
                  />
                </Grid>

                {/* Body */}
                <Typography variant="body2" sx={{ mb: 2 }}>
                  Attenzione! In caso di operazioni con più di 20 firmatari,
                  contattare il team tecnico prima di avviare la firma.
                </Typography>

                <Grid item xs={12} sx={{ mb: 2 }}>
                  <Typography
                    style={{ fontSize: "14px" }}
                    className="color-dark-blue"
                  >
                    Nome
                  </Typography>

                  <TextField
                    fullWidth
                    size="small"
                    name="signer_firstname"
                    error={missingFields.includes("signer_firstname")}
                    value={signerData.signer_firstname}
                    onChange={handleChange}
                    placeholder="Inserisci"
                    variant="outlined"
                    style={{ marginTop: "5px" }}
                  />
                </Grid>

                <Grid item xs={12} sx={{ mb: 2 }}>
                  <Typography
                    style={{ fontSize: "14px" }}
                    className="color-dark-blue"
                  >
                    Cognome
                  </Typography>

                  <TextField
                    style={{ marginTop: "5px" }}
                    fullWidth
                    size="small"
                    name="signer_lastname"
                    error={missingFields.includes("signer_lastname")}
                    value={signerData.signer_lastname}
                    onChange={handleChange}
                    placeholder="Inserisci"
                    variant="outlined"
                  />
                </Grid>

                <Grid item xs={12} sx={{ mb: 2 }}>
                  <Typography
                    style={{ fontSize: "14px" }}
                    className="color-dark-blue"
                  >
                    Email
                  </Typography>

                  <TextField
                    style={{ marginTop: "5px" }}
                    fullWidth
                    type="email"
                    size="small"
                    name="signer_email"
                    value={signerData.signer_email}
                    error={missingFields.includes("signer_email")}
                    onChange={handleChange}
                    placeholder="Inserisci"
                    variant="outlined"
                  />
                  <Typography
                    className={colorMessage}
                    style={{ fontSize: "14px", marginTop: "5px" }}
                  >
                    {messageEmailValidation}
                  </Typography>
                </Grid>

                {authenticationMode !== "none" && authenticationMode !== "otp_email" && (
                  <Grid item xs={12} sx={{ mb: 2 }}>
                    <Typography
                      style={{ fontSize: "14px" }}
                      className="color-dark-blue"
                    >
                      Numero di telefono
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={6} sm={3}>
                        <Autocomplete
                          options={mobilePrefixes}
                          value={mobilePrefixes.find(c => c.dial_code === prefix) || null}
                          onChange={(event, newValue) => {
                            handleChangeDropDown({ target: { value: newValue?.dial_code || "+39" } });
                          }}
                          getOptionLabel={(option) => `${option.emoji} ${option.dial_code}`}
                          filterOptions={(options, { inputValue }) => {
                            const searchTerm = inputValue.toLowerCase();
                            return options.filter(
                              (option) =>
                                option.name.toLowerCase().includes(searchTerm) ||
                                option.dial_code.includes(searchTerm) ||
                                option.code.toLowerCase().includes(searchTerm)
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Cerca..."
                              style={{ marginTop: "5px" }}
                            />
                          )}
                          renderOption={(props, option) => (
                            <Box
                              component="li"
                              {...props}
                              sx={{
                                overflow: { xs: 'hidden' },
                                textOverflow: { xs: 'ellipsis' },
                                whiteSpace: { xs: 'nowrap' },
                              }}
                            >
                              {option.emoji} {option.dial_code} - {option.name}
                            </Box>
                          )}
                          isOptionEqualToValue={(option, value) => option.code === value.code}
                        />
                      </Grid>
                      <Grid item xs={6} sm={9}>
                        <TextField
                          style={{ marginTop: "5px" }}
                          fullWidth
                          error={missingFields.includes("signer_phone_number")}
                          name="signer_phone_number"
                          value={signerData.signer_phone_number}
                          onChange={handleChange}
                          placeholder="Inserisci"
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                )}

                {/* Footer */}
                <Grid
                  item
                  xs={12}
                  sx={{
                    mt: 4,
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 2,
                  }}
                >
                  {isEditMode && (
                    <Button
                      variant="outlined"
                      className="button-bg-light-blue"
                      sx={{
                        width: {
                          xs: "100px !important",
                          sm: "160px !important",
                        },
                      }}
                      onClick={handleRemoveSigner(changeSigner.email)}
                    >
                      <Typography
                        className="color-blue-dark"
                        sx={{
                          textTransform: "initial",
                          fontSize: { xs: "14px", sm: "18px" },
                          fontWeight: 500,
                        }}
                      >
                        Rimuovi
                      </Typography>
                    </Button>
                  )}

                  <Button
                    onClick={handleSubmitSigner}
                    variant="outlined"
                    className="button-bg-purple"
                    sx={{
                      width: isEditMode ? {
                        xs: "100px !important",
                        sm: "160px !important",
                      } : "100% !important",
                      border: "none !important",
                    }}
                  >
                    <Typography
                      className="color-light"
                      sx={{
                        textTransform: "initial",
                        fontSize: { xs: "14px", sm: "18px" },
                        fontWeight: 500,
                      }}
                    >
                      Salva
                    </Typography>
                  </Button>
                </Grid>
              </Grid>
            </Modal>

            {/* modal reader  */}
            <Modal
              open={openReader}
              onClose={handleGoBackLettore}
              aria-labelledby="change-signer-title"
              aria-describedby="change-signer-description"
            >
              <Grid
                container
                item
                xs={11}
                md={5}
                sx={{
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "#fff",
                  maxHeight: "90vh",
                  overflowY: "auto",
                  borderRadius: 2,
                  boxShadow: 24,
                  p: 3,
                }}
              >
                {/* Header */}
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #c6c6c6",
                    paddingBottom: 2,
                    marginBottom: 2,
                  }}
                >
                  <div style={{ display: "flex" }}>
                    <div className="icon-modal-edit" />
                    <Typography
                      id="change-signer-title"
                      className="color-blue-dark"
                      style={{
                        fontSize: "18px",
                        fontWeight: 600,
                        marginTop: "3px",
                      }}
                    >
                      {editingReader
                        ? "Modifica dati lettore"
                        : "Aggiungi lettore"}
                    </Typography>
                  </div>

                  <div
                    onClick={handleGoBackLettore}
                    className="icon-modal-close"
                    style={{ cursor: "pointer" }}
                  />
                </Grid>

                {/* Body */}
                <Typography sx={{ mb: 2 }}>
                  Lettore: una persona che supervisiona il processo di firma ma
                  non appone la propria firma.
                </Typography>

                <Grid item xs={12} sx={{ mb: 2 }}>
                  <Typography
                    style={{ fontSize: "14px" }}
                    className="color-dark-blue"
                  >
                    Nome
                  </Typography>
                  <TextField
                    style={{ marginTop: "5px" }}
                    fullWidth
                    size="small"
                    name="reader_firstname"
                    error={missingFields.includes("reader_firstname")}
                    defaultValue={readerData.reader_firstname}
                    onChange={handleChangeReader}
                    placeholder="Inserisci"
                    variant="outlined"
                  />
                </Grid>

                <Grid item xs={12} sx={{ mb: 2 }}>
                  <Typography
                    style={{ fontSize: "14px" }}
                    className="color-dark-blue"
                  >
                    Cognome
                  </Typography>
                  <TextField
                    style={{ marginTop: "5px" }}
                    fullWidth
                    size="small"
                    name="reader_lastname"
                    error={missingFields.includes("reader_lastname")}
                    defaultValue={readerData.reader_lastname}
                    onChange={handleChangeReader}
                    placeholder="Inserisci"
                    variant="outlined"
                  />
                </Grid>

                <Grid item xs={12} sx={{ mb: 2 }}>
                  <Typography
                    style={{ fontSize: "14px" }}
                    className="color-dark-blue"
                  >
                    Email
                  </Typography>
                  <TextField
                    style={{ marginTop: "5px" }}
                    fullWidth
                    type="email"
                    size="small"
                    name="reader_email"
                    error={missingFields.includes("reader_email")}
                    value={readerData.reader_email}
                    onChange={handleChangeReader}
                    placeholder="Inserisci"
                    variant="outlined"
                  />
                  <Typography
                    className={colorMessage}
                    style={{ fontSize: "14px", marginTop: "5px" }}
                  >
                    {messageEmailValidation}
                  </Typography>
                </Grid>

                {/* Footer */}
                <Grid
                  item
                  xs={12}
                  sx={{
                    mt: 4,
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 2,
                  }}
                >
                  {editingReader ? (
                    <Button
                      variant="outlined"
                      className="button-bg-light-blue"
                      sx={{
                        width: {
                          xs: "100px !important",
                          sm: "160px !important",
                        },
                      }}
                      onClick={handleRemoveReader(readerData.reader_email)}
                    >
                      <Typography
                        className="color-blue-dark"
                        sx={{
                          textTransform: "initial",
                          fontSize: { xs: "14px", sm: "18px" },
                          fontWeight: 500,
                        }}
                      >
                        Rimuovi
                      </Typography>
                    </Button>
                  ) : (
                    <Grid xs={6} item />
                  )}
                  <Button
                    onClick={handleSaveReader}
                    variant="outlined"
                    className="button-bg-purple"
                    sx={{
                      width: {
                        xs: "100px !important",
                        sm: "160px !important",
                      },
                      border: "none !important",
                    }}
                  >
                    <Typography
                      className="color-light"
                      sx={{
                        textTransform: "initial",
                        fontSize: { xs: "14px", sm: "18px" },
                        fontWeight: 500,
                      }}
                    >
                      Salva
                    </Typography>
                  </Button>
                </Grid>
              </Grid>
            </Modal>
          </form>
        </Grid>
      </Grid>

      <Grid
        container
        className="bg-blue-dark"
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          padding: "15px 0px",
          display: "flex",
          justifyContent: {
            xs: "space-around",
            sm: "center",
          },
          alignItems: "center",
        }}
      >
        <Grid
          container
          sx={{
            paddingLeft: { xs: "20px", sm: "80px" },
            paddingRight: { xs: "20px", sm: "80px" },
          }}
        >
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              className="button-bg-purple"
              onClick={handleConfirmSignModal}
            >
              <Typography
                className="color-light"
                sx={{
                  textTransform: "initial",
                  fontSize: { xs: "16px", sm: "18px" },
                  fontWeight: 500,
                }}
              >
                {"Avvia signing"}
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </Grid>

      {error && (
        <div
          style={{
            width: "360px",
            position: "fixed",
            bottom: "-15px",
            left: "50%",
            backgroundColor: "#fff",
            transform: "translate(-50%, -50%)",
            zIndex: 1000,
            padding: "12px 10px",
            borderRadius: "0px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
            fontSize: "14px",
          }}
        >
          <PopupError
            copyError="Uno o più campi obbligatori non sono stati compilati."
            closePopupError={closePopupError}
          />
        </div>
      )}

      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <CircularProgress style={{ color: "#1b2838" }} />
        </div>
      )}

      <Modal open={modalHelperOpen} onClose={handleCloseHelperModal}>
        <div>
          <ModalHelper
            onClose={handleCloseHelperModal}
            modalObjectInfo={modalObjectInfo}
          />
        </div>
      </Modal>

      <Modal
        open={showSignatureTypeModal}
        disableEscapeKeyDown
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            return;
          }
        }}
      >
        <div>
          <ModalSignatureType onConfirm={handleSignatureTypeConfirm} />
        </div>
      </Modal>

      {errorCall && (
        <Modal open={errorCall} onClose={handleCloseErrorCallModal}>
          <div>
            <ModalError
              title={messageError.title}
              descriptionOne={messageError.descriptionOne}
              descriptionTwo={messageError.descriptionTwo}
              copyButton="Chiudi"
              confirm={handleCloseErrorCallModal}
              onClose={handleCloseErrorCallModal}
            />
          </div>
        </Modal>
      )}

      <Modal open={confirmSignModal} onClose={handleCloseModalConfirmSign}>
        <div>
          <ModalConferma
            title="Avvia signing"
            descriptionOne="L'avvio del signing è un azione irreversibile che determina l'inoltro delle notifiche ai firmatari e l'attivazione dei relativi certificati di firma (costi a carico di LEXIA). Confermi di voler procedere?"
            descriptionTwo=""
            copyButton="Procedi"
            confirm={subimtData}
            onClose={handleCloseModalConfirmSign}
          />
        </div>
      </Modal>

      {successStart && (
        <Modal open={successStart} onClose={handleCloseSuccessStartModal}>
          <ModalSuccess
            title="Pratica di firma creata con successo!"
            descriptionOne={`Puoi seguire l'operazione nella schermata "Signing in corso".`}
            descriptionTwo=""
            copyButton="Chiudi"
            confirm={handleCloseSuccessStartModal}
            onClose={handleCloseSuccessStartModal}
          />
        </Modal>
      )}
    </>
  );
};

export default NuovaPraticaForm;